import type { ResourceType } from './common';

/**
 * Notification to be presented to renderer components
 */
export interface Notification {
    eventName: string;
    timestamp: string;
    keys: Record<string, string>;
    data: Record<string, string>;
    componentName: string;
    failed?: boolean;
    header?: string;
}

/**
 * Raw notification received from AWS
 */
export interface RawBackendNotification {
    app: string;
    resource: ResourceType | 'broadcast'
    resourceId?: string
    tenantId: string
    userId: string
    time: string
    action: string
    keys: string
    data: string
}

/**
 * Parsed notification where keys and data converted to objects
 */
export interface BackendNotification<T = Record<string, unknown>> extends Omit<RawBackendNotification, 'keys' | 'data'> {
    eventName: string;
    app: string;
    resource: ResourceType | 'broadcast'
    resourceId?: string
    tenantId: string
    userId: string
    time: string
    action: string
    keys: Record<string, string>
    data: T // TODO add proper typing for different kinds of backend events
}

export interface OnEventPublished {
    onEventPublished: RawBackendNotification;
}

export enum NotificationActionType {
    SHOW_TOAST = 'SHOW_TOAST',
    ADD_NOTIFICATION = 'ADD_NOTIFICATION'
}

export interface Payload extends Record<string, unknown> {}

export interface ShowToastPayload extends Payload {
    summary?: string;
    detail: string;
    severity?: 'success' | 'error' | 'warn' | 'info';
}

export interface AddNotificationPayload extends Payload {
    notification: Notification;
}

export interface NotificationAction {
    actionType: NotificationActionType;
    payload: Payload;
}

export type NotificationActionProducer = (notification: BackendNotification) => (NotificationAction | undefined)
